module.exports = __webpack_public_path__ + "assets/images/43be3f0e4890dda9a0f11f8dbd2e5e13.png";